<div class="container">
  <!-- Section droit : Tableau des EAN -->
  <div class="table-container left-panel">
    <div class="search-header">
      <h3>Ean Orphelins</h3>
      <mat-form-field appearance="outline" class="padding-x wide flexible-input">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Rechercher</mat-label>
        <input
          matInput
          [(ngModel)]="globalFilter"
          (input)="applyFilter(globalFilter)"
          placeholder="ean , désignation"
        />
        <button
          mat-icon-button
          matSuffix
          class="padding-x"
          *ngIf="globalFilter"
          aria-label="Clear"
          (click)="applyFilter((globalFilter = ''))"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="table-scroll-container">
      <table mat-table [dataSource]="eanOrphelinDataSource" class="mat-elevation-z8">
        <!-- Colonne Select -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-radio-group [(ngModel)]="selectedEan">
              <mat-radio-button [value]="row"></mat-radio-button>
            </mat-radio-group>
          </td>
        </ng-container>

        <!-- Colonne Code EAN -->
        <ng-container matColumnDef="codeEan">
          <th mat-header-cell *matHeaderCellDef>Code EAN</th>
          <td mat-cell *matCellDef="let row">{{ row.eanOrphelin }}</td>
        </ng-container>

        <!-- Colonne Désignation -->
        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef>Désignation</th>
          <td mat-cell *matCellDef="let row">{{ row.designationOrphelin }}</td>
        </ng-container>

        <!-- Header et Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
  <!-- Section droit : Liste des produits -->
  <div class="right-panel">
    <h3>Sélectionner un produit</h3>
    <mat-form-field appearance="outline" class="produit padding-x">
      <mat-label>Produit</mat-label>
      <mat-select [(value)]="selectedProduct">
        <mat-option *ngFor="let product of eanList" [value]="product" class="product-option">
          {{ product.ean + ' / ' + product.designation }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<!-- Boutons d'action -->
<div class="actions">
  <button mat-stroked-button class="valider padding-x" (click)="onSubmit()">Rattacher</button>
</div>
